<template>
  <div class="lineChart">
    <Loader v-if="nodata && !emptyData" />
    <div v-if="emptyData">No Data Found</div>
    <div class="svgWrapper" :style="{ width: canvasWidth + 'px', height: canvasHeight + 'px' }">
      <svg :width="canvasWidth" :height="canvasHeight" ref="svg">
        <g ref="chart" :transform="transform">
          <path :d="valueline" class="line"  />

          <circle v-for="(point, index) in points"
            class="point"
            :cx="scaled.x(point.x)"
            :cy="scaled.y(point.y)"
            :r="circles.size"
            v-bind:key="index"
            @mouseover="showCircleData(point)"
            @mouseout="hideCircleData"
            />
          <g ref="axis">
            <Axis ref="axisLeft" position="left" :scaled="scaled.y" />
            <Axis ref="axisBottom" position="bottom" :scaled="scaled.x" :translateY="height" tickFormat="date" />
          </g>
        </g>
      </svg>
      <div class="tooltip"></div>
    </div>
  </div>
</template>

<script>
// https://medium.com/tyrone-tudehope/composing-d3-visualizations-with-vue-js-c65084ccb686
import * as d3 from 'd3'
import Loader from '@/components/elements/Loader'
import Axis from '@/components/d3/Axis'
const props = {
  data: {
    type: Array,
    default: () => [{'users': 1, 'date': '2019-07-01'}, {'users': 3, 'date': '2019-07-02'}, {'users': 2, 'date': '2019-07-03'}]
  },
  margin: {
    type: Object,
    default: () => ({
      left: 50,
      right: 20,
      top: 20,
      bottom: 30
    })
  },
  canvasWidth: {
    type: Number,
    default: 960
  },
  canvasHeight: {
    type: Number,
    default: 500
  },
  axis: {
    type: Object,
    default: () => ({
      dateFormat: '%B %d, %Y',
      numberFormat: 'd'
    })
  },
  emptyData: {
    type: Boolean,
    default: false
  },
  circles: {
    type: Object,
    default: () => ({
      use: true,
      size: 5
    })
  }
}
export default {
  name: 'd3-line-chart',
  props,
  components: {
    'Loader': Loader,
    'Axis': Axis
  },
  data () {
    return {
      scaled: {
        x: null,
        y: null
      },
      valueline: null,
      path: '',
      chartObject: null,
      points: []
    }
  },
  computed: {
    width () {
      return this.canvasWidth - this.margin.left - this.margin.right
    },
    height () {
      return this.canvasHeight - this.margin.top - this.margin.bottom
    },
    transform () {
      return 'translate(' + this.margin.left + ', ' + this.margin.top + ')'
    },
    nodata () {
      return !this.data
    }
  },
  watch: {
    data () {
      this.initialize()
    }
  },
  async created () {
    if (this.data) {
      await this.initialize()
    }
  },
  methods: {
    parseTime (d) {
      let f = d3.timeParse('%Y-%m-%d')
      return f(d)
    },
    async initialize () {
      let $this = this

      this.points = []
      this.data.forEach(function (d) {
        $this.points.push({
          x: $this.parseTime(d.x),
          y: +d.y
        })
      })

      this.scaled.x = d3.scaleLinear().range([0, this.width])
      this.scaled.y = d3.scaleLinear().range([this.height, 0])

      this.scaled.x.domain(d3.extent(this.points, function (d) { return d.x }))
      this.scaled.y.domain([0, d3.max(this.points, function (d) { return d.y })])

      let createLine = d3.line()
        .x(function (d) { return $this.scaled.x(d.x) })
        .y(function (d) { return $this.scaled.y(d.y) })
      this.valueline = createLine(this.points)
    },
    showCircleData (point) {
      let cx = this.scaled.x(point.x) + this.margin.left
      let cy = this.scaled.y(point.y)

      let timeFormat = d3.timeFormat('%B %d, %Y')
      let xHTML = timeFormat(point.x)
      let yHTML = point.y

      let tooltip = d3.select('.tooltip')
      tooltip
        .style('left', (cx) + 'px')
        .style('top', (cy - 28) + 'px')
        .style('opacity', 1)
        .html(xHTML + ': ' + yHTML)
    },
    hideCircleData () {
      let tooltip = d3.select('.tooltip')
      tooltip.style('opacity', 0)
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';
  .lineChart {
    .svgWrapper {
      position: relative;
      margin: auto;
    }
    .line {
      fill: none;
      stroke: $brandBrightGreen;
      stroke-width: 2px;
    }
    .point {
      fill: $brandBrightGreen;
    }
    .tooltip {
      position: absolute;
      border: 1px solid $brandBlue;
      padding: 5px;
      background-color: $brandBlue25;
      opacity: 0;
      transition: opacity .5s;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/d3/Line.vue